import { toLower } from 'lodash-es'

// const currentDevices = {
//   'iPhone 15 Pro Max': 961,
//   'iPhone 15 Pro': 959,
//   'iPhone 15 Plus': 957,
//   'iPhone 15': 960,

//   'iPhone 14 Pro Max': 961,
//   'iPhone 14 Pro': 638,
//   'iPhone 14 Plus': 318,
//   'iPhone 14': 617,

//   'iPhone 13 Pro Max': 318,
//   'iPhone 13 Pro': 318,
//   'iPhone 13': 635,

//   'iPhone 12 / 12 Pro': 318,

//   'iPhone 11': 315,

//   'Samsung Galaxy S24': 302,
//   'Samsung Galaxy S24 Ultra': 302,

//   'AirPods (1st - 2nd Gen)': 28,
//   'AirPods (3rd Gen)': 28,

//   'Magnetic Wallet': 96,
//   Griptok: 42,
//   'Crossbody Strap': 3,
//   'Wrist Strap': 3,
//   'Crossbody Lanyard': 1,
//   'Wrist Lanyard': 1
// }

const getProductPageUrlBySearch = (search: string) => {
  const normalized = toLower(search)
  switch (normalized) {
    case 'iphone 11':
      return '/devices/iphone-11'

    case 'iphone 12':
    case 'iphone 12 pro':
      return '/devices/iphone-12'

    case 'iphone 13':
      return '/devices/iphone-13'
    case 'iphone 13 pro':
      return '/devices/iphone-13-pro'
    case 'iphone 13 pro max':
      return '/devices/iphone-13-pro-max'

    case 'iphone 14':
      return '/devices/iphone-14'
    case 'iphone 14 pro':
      return '/devices/iphone-14-pro'
    case 'iphone 14 plus':
      return '/devices/iphone-14-plus'
    case 'iphone 14 pro max':
      return '/devices/iphone-14-pro-max'

    case 'iphone 15':
      return '/devices/iphone-15'
    case 'iphone 15 pro':
      return '/devices/iphone-15-pro'
    case 'iphone 15 plus':
      return '/devices/iphone-15-pro-plus'
    case 'iphone 15 pro max':
      return '/devices/iphone-15-pro-max'

    case 'samsung galaxy s24':
    case 'samsung  s24':
    case 'galaxy s24':
    case 's24':
      return '/devices/samsung-galaxy-s24'

    case 'samsung galaxy s24 ultra':
    case 'galaxy s24 ultra':
    case 's24 ultra':
      return '/devices/samsung-galaxy-s24-ultra'

    case 'airpods 1':
    case 'airpods 2':
    case 'airpods (1st - 2nd gen)':
      return '/devices/airpods-1st-2nd-gen'
    case 'airpods 3':
    case 'airpods (3rd gen)':
      return '/devices/airpods-3rd-gen'

    default:
      return '/products?search=' + search
  }
}

export default getProductPageUrlBySearch
